
<template>
  <action-sheet
    v-model="show"
    :close-on-click-overlay="false"
  >
    <div class="action-content">
      <div class="header">
        <h1>选{{loanProcessTitle}}计划</h1>
        <p>当前提现通道拥挤程度<span class="red">89.7%，</span>选{{loanProcessTitle}}抢先拿钱！</p>
      </div>
      <i
        class="close"
        @click="show=false"
      ></i>
      <div class="content-detail"><span>{{loanProcessTitle}}</span></div>
      <div class="btn-container">
        <div
          data-sensors-click
          class="nomal"
          @click="nomalTips"
        >普通提现</div>
        <div
          class="bvip-btn"
          data-sensors-click
          @click="show = false;;$emit('on-withdraw')"
        >
          <p>{{loanProcessTitle}}专属提现</p>
          <span><template v-if="isWHD">约</template>{{greatVIPCoupon.termAmount | currency}}元/期 (共{{greatVIPCoupon.countTerm}}期)</span>
        </div>
      </div>
      <div class="protocol">
        点击「{{loanProcessTitle}}专属提现」表示您已阅读并同意 <span @click="$emit('on-protocol')">《相关协议》</span>
      </div>
    </div>
  </action-sheet>
</template>

<script>
import { ActionSheet } from 'vant'
export default {
  components: {
    ActionSheet
  },
  data () {
    return {}
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    greatVIPCoupon: {
      type: Object,
      default: () => {}
    },
    loanProcessTitle: {
      type: String,
      default: '大权益'
    },
    isWHD: {
      type: Boolean,
      default: false
    }
  },

  async mounted () {},
  methods: {
    nomalTips () {
      this.show = false
      this.$indicator()
      setTimeout(() => {
        this.$indicator.close()
        this.$message('普通提现通道拥挤，请稍后再试')
      }, 2000)
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.van-popup {
  background: #fff;
  .btn-container {
    display: flex;
    margin-top: 40px;
    justify-content: space-between;
    .nomal {
      width: 230px;
      height: 94px;
      background: #fff4f4;
      border-radius: 47px;
      font-family: PingFangSC, PingFang SC;
      font-size: 28px;
      color: #ff4633;
      text-align: center;
      line-height: 94px;
    }
    .bvip-btn {
      width: 450px;
      height: 94px;
      background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
      border-radius: 47px;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      p {
        background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
        border-radius: 47px;
        font-size: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
      }
      span {
        font-size: 24px;
      }
    }
  }
  .action-content {
    height: 927px;
    padding: 60px 30px 40px;
    &:before {
      content: "";
      background: linear-gradient(180deg, #ffe3c4 0%, #ffffff 100%);
      height: 180px;
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
    }
    &:after {
      content: "";
      position: absolute;
      width: 406px;
      height: 333px;
      background: url("./bg.png") no-repeat;
      background-size: 100% 100%;
      left: 30px;
      top: 0;
    }
    .close {
      position: absolute;
      width: 32px;
      height: 32px;
      background: url("./btn_close_white@2x.png") no-repeat;
      background-size: 100% 100%;
      right: 30px;
      top: 60px;
      z-index: 2;
    }
    .header {
      position: relative;
      z-index: 1;
      h1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 42px;
        color: #333333;
        line-height: 50px;
      }
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #333333;
        line-height: 33px;
        margin: 10px 0 30px;
      }
    }
    .red {
      color: #ff4633;
    }
    .content-detail {
      position: relative;
      z-index: 1;
      width: 692px;
      height: 520px;
      background: url("./info.png") no-repeat;
      background-size: 100% 100%;
      padding-left: 490px;
      padding-top: 35px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 26px;
      color: #763e12;
      line-height: 50px;
      span{
        width: 140px;
        display: block;
        text-align: center;
      }
     
    }
    .protocol {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #999999;
      line-height: 33px;
      text-align: center;
      margin-top: 20px;
      span {
        color: #8eb2d8;
      }
    }
  }
}
</style>
